import { Elements } from "@/components/elements";
import { Link } from "@/lib/router";
import { FOUNDING_TEAM } from "@/utils/constants";


export const FoundingTeam = () => {
    return (
        <section className="overflow-hidden px-5 pb-20 md:px-10 lg:px-[79px] bg-brand-100">
            <div className="flex flex-col items-center justify-center gap-8">
                <div className="flex flex-col items-center justify-center gap-4">
                    <Elements.Title title="The Founders of Predictable Benefits" type="h1" className="text-center text-gray-900 text-4xl md:text-5xl" />
                    <Elements.Description description="The leaders behind Predictable Benefits, focused on building the infrastructure that powers modern ICHRA distribution." type="medium" className="text-center text-gray-900 text-sm md:text-lg max-w-[725px]" />
                </div>
                <div className="mx-auto w-full max-w-[1200px] grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4 items-stretch">
                    {FOUNDING_TEAM.map((member) => (
                        <Elements.FoundingTeamCard key={member.name} {...member} />
                    ))}
                </div>

                <div className="flex w-full max-w-[725px] justify-center">
                    <Link
                        to="/company/advisors"
                        className="btn btn-primary btn-lg w-full"
                    >
                        <span className="text-base md:text-xl lg:text-xl">Meet Our Advisors</span>
                    </Link>
                </div>
            </div>
        </section>
    );
};
